<template>
  <CContainer fluid>
    <CRow alignHorizontal="between">
      <div class="row-card-title left">
        <div>
          <div class="card-title-active">Revenue</div>
          <div class="line" />
        </div>
      </div>
      <div class="row-card-title right">
        <div class="custom-button-view-all">
          <div class="card-titile-view-all">VIEW ALL</div>
        </div>
      </div>
    </CRow>
    <CRow>
      <div class="main-card">
        <CContainer fluid>
          <CRow alignHorizontal="between">
            <div>
              <graphViewTypeComponent />
            </div>
          </CRow>
          <CRow>
            <CCol>
              <CChartBar :datasets="getMfuAndMdlData()" labels="months" />
              <CRow>
                <template v-for="detail in details">
                  <CCol
                    :key="detail.label"
                    style="display: flex; flex-direction: column; align-content: center; justify-content: center"
                  >
                    <div style="font-size:18px; text-align: center">{{capilalize(detail.month)}}</div>
                    <strong
                      style="color: #002B9C; font-size: 12px; text-align: center"
                    >{{detail.mfu}}</strong>
                    <strong
                      style="color: #FB9879; font-size: 12px; text-align: center"
                    >{{detail.mdl}}</strong>
                  </CCol>
                </template>
              </CRow>
            </CCol>
          </CRow>
        </CContainer>
      </div>
    </CRow>
  </CContainer>
</template>

<script>
import { CChartBar } from "@coreui/vue-chartjs";
import graphViewTypeComponent from "../dashboard/graphViewTypeComponent";
import Axios from "axios";
export default {
  name: "Revenue",
  components: {
    CChartBar,
    graphViewTypeComponent
  },
  mounted() {
    this.getLineChartData();
  },
  data() {
    return {
      details: [],
      munOfMfuUser: [],
      munOfMdlUser: []
    };
  },
  methods: {
    capilalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    getLineChartData(viewType) {
      Axios.post("http://10.1.134.48:2000/api/account/summary").then(
        response => {
          this.setDetails(response.data.mfu, response.data.mdl);
          this.setMunOfMfuUser(response.data.mfu);
          this.setMunOfMdlUser(response.data.mdl);
        }
      );
    },
    setMunOfMfuUser(data) {
      for (let x of data) this.munOfMfuUser.push(x.value);
    },
    setMunOfMdlUser(data) {
      for (let x of data) this.munOfMdlUser.push(x.value);
    },
    getMfuAndMdlData() {
      return [
        {
          data: this.munOfMfuUser,
          backgroundColor: "rgba(0, 29, 197, 0.5)",
          label: "MFU"
        },
        {
          data: this.munOfMdlUser,
          backgroundColor: "rgba(255, 180, 156, 0.5)",
          label: "MDL"
        }
      ];
    },
    setDetails(mfu, mdl) {
      if (mfu.length == mdl.length)
        for (let i = 0; i < mfu.length; i++)
          if (mfu[i].month == mdl[i].month)
            this.details.push({
              month: mfu[i].month,
              mfu: mfu[i].value,
              mdl: mdl[i].value
            });
    }
  }
};
</script>
